import { useState } from "react";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, errText } from "@/lib/api";

export const STATUSES = [
  { value: "new", label: "New" },
  { value: "contacted", label: "Contacted" },
  { value: "visited", label: "Visited" },
  { value: "closed", label: "Closed" },
];

export const EnquiryStatusSelect = ({ enquiry, onUpdated }) => {
  const [status, setStatus] = useState(enquiry.status || "new");
  const [busy, setBusy] = useState(false);

  const change = async (value) => {
    const prev = status;
    setStatus(value);
    setBusy(true);
    try {
      const { data } = await api.patch(`/enquiries/${enquiry.enquiry_id}`, { status: value });
      toast.success(`Marked as ${STATUSES.find((s) => s.value === value)?.label}`);
      onUpdated?.(data);
    } catch (err) {
      setStatus(prev);
      toast.error(errText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Select value={status} onValueChange={change} disabled={busy}>
      <SelectTrigger className="h-9 w-[135px] rounded-lg text-xs font-semibold" data-testid={`enquiry-status-select-${enquiry.enquiry_id}`}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {STATUSES.map((s) => (
          <SelectItem key={s.value} value={s.value} data-testid={`status-option-${s.value}`}>
            {s.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default EnquiryStatusSelect;
